export const CHECKOUT_URL = "https://otplanning-en.impultienda.ar/checkout/";

export const images = {
  mockup: "https://cdn.magicpatterns.com/uploads/5GNHRhLLnE3c3k7zgfruNG/MOCKUP_OT_PLANNING-EN.png",
  author: "https://cdn.magicpatterns.com/uploads/fgimbJrBYbNpCqj7huD5LV/Dr._Elena_Martins_-_AAC.png",
};

export const toolkitItems = [
  "6 practical planning workbooks",
  "5 exclusive bonus resource packs",
  "Session preparation templates",
  "Goal organization worksheets",
  "Caseload and weekly planning tools",
  "Progress-tracking and documentation organizers",
];

export const workTowardItems = [
  "Organizing session preparation with reusable worksheets.",
  "Keeping planning goals and priorities in a structured format.",
  "Reviewing your weekly schedule and outstanding tasks.",
  "Recording observations using organized templates.",
  "Maintaining a consistent approach to documentation preparation.",
  "Planning follow-up tasks and reviewing what needs attention next.",
];

export const beforeItems = [
  "Searching through multiple files to find the right planning document.",
  "Recreating worksheets because you cannot find an existing template.",
  "Managing session preparation separately from your weekly planning.",
  "Looking for a consistent format to organize goals and observations.",
  "Trying to remember which administrative tasks still need attention.",
];

export const afterItems = [
  "Keeping your essential planning templates together.",
  "Preparing sessions with a repeatable framework.",
  "Organizing goals and priorities in dedicated worksheets.",
  "Recording relevant observations in a consistent format.",
  "Reviewing follow-up tasks through structured planning pages.",
];

export const challenges = [
  {
    title: "Your Planning Documents Are Scattered",
    text: "You have useful notes, worksheets, and organizers, but they aren’t always easy to locate when you need them.",
  },
  {
    title: "Preparing Sessions Takes Too Much Organization",
    text: "You want a consistent preparation routine instead of repeatedly deciding how to organize the information before every session.",
  },
  {
    title: "You Need a Better Way to Organize Goals",
    text: "You want structured worksheets to help record goals, priorities, and planning notes without building a new document for every task.",
  },
  {
    title: "Documentation Requires a Consistent Workflow",
    text: "You want a practical way to organize documentation tasks while continuing to follow the standards and requirements of your professional setting.",
  },
  {
    title: "Your Weekly Responsibilities Keep Adding Up",
    text: "Appointments, preparation, documentation, and follow-up tasks compete for your attention.",
  },
  {
    title: "You Want Practical Resources Without Complicated Software",
    text: "You prefer adaptable templates and planning documents that can complement the tools you already use.",
  },
];

export const includedItems = [
  "Six practical digital workbooks",
  "Five complementary bonus resource packs",
  "Session planning and preparation templates",
  "Goal organization worksheets",
  "Weekly workflow and caseload organizers",
  "Progress-tracking and documentation resources",
];

export const volumes = [
  {
    title: "Pediatric OT Session Planning Framework",
    tagline: "Build a Consistent Structure for Preparing Your Sessions",
    description: "A practical workbook for organizing the preparation tasks and information you want to review before a session.",
    inside: [
      "Session preparation worksheets",
      "Pre-session planning checklists",
      "Session priority organizers",
      "Planning notes templates",
      "Session review worksheets",
      "Reusable preparation frameworks",
    ],
    benefit: "A structured place to organize your session preparation instead of starting from a blank page every time.",
    note: "",
    color: "#fbd0d9",
  },
  {
    title: "Pediatric OT Goals & Intervention Planning Organizer",
    tagline: "Organize Planning Priorities and Goals in One Place",
    description: "Use these worksheets to organize relevant information, record goals, and structure planning discussions within your professional role.",
    inside: [
      "Goal organization worksheets",
      "Planning priority matrices",
      "Goal review templates",
      "Session objective organizers",
      "Goal-to-session planning worksheets",
      "Review and revision checklists",
    ],
    benefit: "A consistent organizational framework for reviewing goals and connecting them with your planning process.",
    note: "Clinical goals and intervention decisions must be individualized by the responsible professional.",
    color: "#bfece2",
  },
  {
    title: "Pediatric OT Caseload & Weekly Workflow Planner",
    tagline: "Bring Your Weekly Planning Tasks Together",
    description: "When several cases require attention, a clear overview can help you organize preparation, scheduling, and administrative responsibilities.",
    inside: [
      "Weekly planning pages",
      "Caseload overview worksheets",
      "Appointment preparation checklists",
      "Task-priority organizers",
      "Follow-up task trackers",
      "Weekly review templates",
    ],
    benefit: "A structured overview of your planning responsibilities and the tasks that need attention.",
    note: "",
    color: "#dccdf6",
  },
  {
    title: "Pediatric OT Progress Tracking & Observation Workbook",
    tagline: "Organize Observations and Information for Review",
    description: "This workbook provides templates for organizing observations and recording relevant information over time, according to your professional responsibilities.",
    inside: [
      "Observation recording sheets",
      "Progress review templates",
      "Session-to-session comparison worksheets",
      "Goal review logs",
      "Follow-up observation organizers",
      "Progress summary planning pages",
    ],
    benefit: "A repeatable format for organizing observations and reviewing documented information.",
    note: "These worksheets do not replace validated assessment instruments or establish clinical outcome measures.",
    color: "#fde39a",
  },
  {
    title: "Pediatric OT Clinical Documentation Organizer",
    tagline: "Create a More Structured Documentation Workflow",
    description: "Use adaptable templates to organize documentation tasks and review the information required in your professional setting.",
    inside: [
      "Session note planning templates",
      "Documentation preparation checklists",
      "Information organization worksheets",
      "Note completion checklists",
      "Documentation review pages",
      "Follow-up and pending-item trackers",
    ],
    benefit: "A practical framework for organizing documentation tasks while continuing to follow your workplace’s requirements.",
    note: "Templates must be adapted to applicable regulations, professional standards, and institutional policies.",
    color: "#c5e0f8",
  },
  {
    title: "Pediatric OT Practice Review & Follow-Up System",
    tagline: "Organize What Needs Attention After Each Session",
    description: "A collection of planning tools for reviewing tasks, organizing follow-up responsibilities, and preparing for the next stage of your workflow.",
    inside: [
      "Post-session review worksheets",
      "Follow-up planning templates",
      "Pending-task organizers",
      "Weekly reflection pages",
      "Planning adjustment worksheets",
      "Next-session preparation checklists",
    ],
    benefit: "A structured way to organize what needs to be reviewed, completed, or prepared next.",
    note: "",
    color: "#c8eec9",
  },
];

export const tools = [
  { title: "Session Preparation Checklist", text: "A reusable checklist for organizing preparation tasks before a session." },
  { title: "Weekly OT Planning Sheet", text: "A weekly overview for organizing priorities, appointments, preparation tasks, and follow-up responsibilities." },
  { title: "Goal Review Worksheet", text: "A structured worksheet for recording goals and organizing information for review." },
  { title: "Documentation Completion Checklist", text: "A reminder tool to help you review documentation requirements according to your workplace’s standards." },
  { title: "Post-Session Review Sheet", text: "A worksheet for organizing relevant observations, pending tasks, and preparation priorities for the next session." },
];

export const bonuses = [
  {
    title: "The Pediatric OT Weekly Planner Pack",
    image: "https://cdn.magicpatterns.com/uploads/jdiq4JnMJSRurQpazJL6SJ/BONUS_1_OT_PLANNING-EN.png",
    lead: "Bring your weekly responsibilities into one organized overview.",
    includes: ["Weekly overview template", "Daily task planner", "Priority checklist", "Follow-up organizer", "End-of-week review sheet"],
    note: "Use these pages to structure your week and identify the tasks that need attention.",
    color: "#fbd0d9",
  },
  {
    title: "The OT Goal Organization Worksheet Pack",
    image: "https://cdn.magicpatterns.com/uploads/1k5JUnWBTiqJ6bEV6WjaVd/BONUS_2_OT_PLANNING-EN.png",
    lead: "Keep goal-planning information organized with reusable worksheets.",
    includes: ["Goal recording sheets", "Goal review worksheets", "Planning priority templates", "Goal discussion notes", "Review date organizers"],
    note: "These are organizational tools, not standardized assessments or validated clinical goal-setting instruments.",
    color: "#bfece2",
  },
  {
    title: "The Pediatric OT Progress Tracking Pack",
    image: "https://cdn.magicpatterns.com/uploads/rDr8XUc8eHf3pas1KydJfo/BONUS_3_OT_PLANNING-EN.png",
    lead: "Organize observations and documented information with a collection of practical worksheets.",
    includes: ["Observation logs", "Progress review pages", "Session comparison worksheets", "Follow-up recording sheets", "Progress summary organizers"],
    note: "Use only measures and documentation methods appropriate to your professional setting.",
    color: "#dccdf6",
  },
  {
    title: "The OT Documentation Workflow Checklist Pack",
    image: "https://cdn.magicpatterns.com/uploads/ivpLYSbjF9HCqCU5ruD6KB/BONUS_4_OT_PLANNING-EN.png",
    lead: "Structure your documentation tasks with reusable checklists and review pages.",
    includes: ["Documentation preparation checklist", "Note completion checklist", "Information review worksheet", "Pending documentation tracker", "Follow-up task checklist"],
    note: "These checklists supplement, rather than replace, official documentation requirements.",
    color: "#fde39a",
  },
  {
    title: "The Pediatric OT Caseload Organizer Pack",
    image: "https://cdn.magicpatterns.com/uploads/pCUjSPfCNEAhcPZwJww12J/BONUS_5_OT_PLANNING-EN.png",
    lead: "Organize your caseload-related planning and administrative tasks.",
    includes: ["Caseload overview template", "Appointment preparation tracker", "Pending task organizer", "Follow-up schedule worksheet", "Weekly caseload review page"],
    note: "Protect confidential information and follow the privacy, recordkeeping, and data-security requirements that apply to your setting.",
    color: "#c5e0f8",
  },
];

export const valueStack = [
  { label: "Volume 1: Pediatric OT Session Planning Framework", value: 24 },
  { label: "Volume 2: Pediatric OT Goals & Intervention Planning Organizer", value: 24 },
  { label: "Volume 3: Pediatric OT Caseload & Weekly Workflow Planner", value: 24 },
  { label: "Volume 4: Pediatric OT Progress Tracking & Observation Workbook", value: 24 },
  { label: "Volume 5: Pediatric OT Clinical Documentation Organizer", value: 24 },
  { label: "Volume 6: Pediatric OT Practice Review & Follow-Up System", value: 24 },
  { label: "Bonus #1: Pediatric OT Weekly Planner Pack", value: 12 },
  { label: "Bonus #2: OT Goal Organization Worksheet Pack", value: 12 },
  { label: "Bonus #3: Pediatric OT Progress Tracking Pack", value: 12 },
  { label: "Bonus #4: OT Documentation Workflow Checklist Pack", value: 12 },
  { label: "Bonus #5: Pediatric OT Caseload Organizer Pack", value: 12 },
];

export const priceChecks = [
  "Digital planning resources",
  "Practical worksheets and organizers",
  "Multiple planning categories in one collection",
  "Templates you can adapt to your workflow",
  "No recurring subscription charge for this offer",
];

export const testimonials = [
  {
    name: "Mariana López",
    role: "Pediatric OT · Clinic setting",
    topic: "Organization",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/5b8104e7-f431-49f4-bda4-f8c0545ffe5a.jpg",
    quote: "One of the biggest challenges in my daily workflow is keeping planning notes, session preparation, and follow-up tasks organized. Having these resources arranged in one collection would give me a practical starting point instead of creating separate documents from scratch.",
  },
  {
    name: "Rachel Thompson",
    role: "Pediatric OT · Outpatient",
    topic: "Session Preparation",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/30bf3490-028b-40b5-babc-2501f42931e8.jpg",
    quote: "I like the idea of having a consistent structure for preparing sessions. The planning worksheets provide an organized framework that I could adapt to my own routine and use to keep important preparation tasks in one place.",
  },
  {
    name: "Danielle Brooks",
    role: "Pediatric OT · Early intervention",
    topic: "Documentation",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/111c1506-0ccc-4047-bf06-13f9a8c26d70.jpg",
    quote: "The documentation checklists and note organization templates address an important part of my workflow. I appreciate having a clear structure to work from while still following the documentation requirements of my professional setting.",
  },
  {
    name: "Andrés Ramírez",
    role: "Pediatric OT · Private practice",
    topic: "Weekly Planning",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/72d59438-81e3-4965-97d7-916c498e7ecb.jpg",
    quote: "Managing appointments, preparation tasks, and follow-ups requires organization. A weekly planning system like this gives me a practical way to bring those responsibilities together and review what needs attention throughout the week.",
  },
  {
    name: "Katie Hansen",
    role: "School-based OT",
    topic: "Practical Resources",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/7d7b53ec-f71d-44b7-8a56-5452156403af.jpg",
    quote: "What stands out to me is that the collection brings several planning tools together rather than focusing on just one task. I can see the value of having worksheets for session preparation, goal organization, progress tracking, and follow-up in one place.",
  },
];

export const faqs = [
  {
    q: "What is the Pediatric OT Planning System™?",
    a: "It’s a digital collection containing six planning workbooks and five bonus resource packs. The materials focus on organizing session preparation, goals, caseload information, observations, documentation tasks, and follow-up.",
  },
  {
    q: "Who is this collection designed for?",
    a: "It’s intended for pediatric occupational therapy professionals who want practical organizational tools for their work. Students and other learners may also find some resources useful for educational planning, subject to their program requirements and supervision.",
  },
  {
    q: "Is this a clinical treatment protocol?",
    a: "No. It is an educational and organizational toolkit. It does not prescribe treatment, diagnose conditions, replace professional assessment, or establish a validated clinical method.",
  },
  {
    q: "Can I adapt the worksheets to my workflow?",
    a: "Yes. The templates are designed to be adaptable. Review them and determine how they can appropriately complement your professional responsibilities and workplace requirements.",
  },
  {
    q: "Will I receive physical books?",
    a: "No. This is a digital product — no physical books are shipped.",
  },
  {
    q: "Can I download the files?",
    a: "Access and download instructions are provided at checkout and in your delivery message after purchase.",
  },
  {
    q: "Is this a recurring subscription?",
    a: "No. The offer described on this page is a one-time payment of $27 USD, not a recurring subscription.",
  },
  {
    q: "Does this replace my workplace’s documentation system?",
    a: "No. Use the templates as supplementary planning resources. Follow the official systems, documentation standards, privacy requirements, and applicable regulations for your professional setting.",
  },
  {
    q: "Can I share the files with colleagues?",
    a: "The files are licensed for the purchaser’s personal professional use. Please review the terms of use before sharing any materials.",
  },
  {
    q: "What is your refund policy?",
    a: "Please review the seller’s stated refund policy at checkout before purchasing.",
  },
  {
    q: "How quickly can I start using the resources?",
    a: "Once you receive access, you can begin with the worksheets most relevant to your planning needs. Review and adapt each resource before using it in your professional workflow.",
  },
];

export const recentBuyers = [
  { name: "Valentina R.", country: "Colombia" },
  { name: "Camila G.", country: "Mexico" },
  { name: "Sofía M.", country: "Argentina" },
  { name: "Lucía F.", country: "Spain" },
  { name: "Daniela P.", country: "Chile" },
  { name: "Mariana T.", country: "Peru" },
  { name: "Gabriela S.", country: "Ecuador" },
  { name: "Isabella C.", country: "Uruguay" },
  { name: "Andrea V.", country: "Costa Rica" },
  { name: "Paula H.", country: "Dominican Republic" },
  { name: "Natalia J.", country: "Guatemala" },
  { name: "Fernanda O.", country: "Puerto Rico" },
  { name: "Carolina B.", country: "Paraguay" },
  { name: "Alejandra N.", country: "Panama" },
  { name: "Ximena D.", country: "Bolivia" },
];

export const SPOTS_LEFT = 7;
export const SPOTS_TOTAL = 100;
